var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1778_16951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18L12 16.7165L8 18L4 16.7165L0 18V0H11.2L16 4.69565V18Z",
    fill: "#0054E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 4.75043H16.0002L11.2002 0V4.75043Z",
    fill: "#BCB9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 6.71484H3.93555V7.36441H12.6875V6.71484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 9.43054H3.93555V10.0801H12.6875V9.43054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_16951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.7b285713b7eb9218dea986941e443231.svg";
export { ForwardRef as ReactComponent };